@if (fields.length > 0) {
  <form [formGroup]="fieldForm">
    @for (item of fields; track item.field.id) {
    <div class="filter-control-group">
      <label class="label">{{ item.collectionTitle }} – {{ item.field.name }}</label>

      @switch (item.field.composition.valueType) {
        @case (ValueTypeEnum.Boolean) {
          <nb-select [formControlName]="item.field.id" placeholder="Beliebig">
            <nb-option [value]="null">Beliebig</nb-option>
            <nb-option [value]="true">Ja</nb-option>
            <nb-option [value]="false">Nein</nb-option>
          </nb-select>
        }
        @case (ValueTypeEnum.Integer) {
          <input nbInput type="number" step="1" [formControlName]="item.field.id" placeholder="Wert...">
        }
        @case (ValueTypeEnum.Double) {
          <input nbInput type="number" step="any" [formControlName]="item.field.id" placeholder="Wert...">
        }
        @default {
          <input nbInput type="text" [formControlName]="item.field.id" placeholder="Filter...">
        }
      }
    </div>
    }
  </form>
}
